module.exports = __webpack_public_path__ + "img/SJ.e504e504.png";